import { Typography } from "@mui/material";

export default function LeagueSpartanText({ sx, ...props }) {
  return (
    <Typography
      {...props}
      sx={{ fontFamily: "'League Spartan', Arial, sans-serif", ...sx }}
    />
  );
}